<div class="sentiment-analysis" *ngIf="sentimentAnalysis">
   
    <div class="sentiment-analysis__header">
        <h6 class="categories-heading">Categories</h6>
        <label class="toggle-details" (click)="toggleDescriptions()">
            {{ showDescriptions ? 'Hide' : 'Show' }} details
        </label>
    </div>

    <div class="sentiment-analysis__row row">
        <div class="col-12 col-lg-4 sentiment-analysis__col" *ngFor="let category of sentimentAnalysis.categories">
            <div class="sentiment-analysis__rating">
                <div class="rating-header">
                    <p class="name">
                        {{ category?.name }}
                    </p>
                    <span class="rating-value">
                        {{ category?.rating }}
                    </span>
                </div>
                <mat-progress-bar 
                    [value]="(category?.rating || 0)*10"
                    [ngClass]="{'rating-yellow': (category?.rating || 0) < 8}">
                </mat-progress-bar>
                <p class="rating-description" *ngIf="showDescriptions">
                    {{ category?.description }}
                </p>
            </div>
        </div>
    </div>
</div>